export default "__VITE_ASSET__Br0JnQDJ__"